/**
 * Resolve the backend WS base URL.
 *
 * Priority:
 * 1. Build-time env `VITE_BACKEND_WS_URL` (set by the deploy pipeline in prod
 *    to `wss://api.thegamer.network`).
 * 2. Auto-derive from page origin: HTTPS page on `<sub>.<apex>` maps to
 *    `wss://api.<apex>` (strips the current subdomain, substitutes `api.`).
 *    Covers the common whatis.→api. swap without needing an env var.
 * 3. Dev fallback: `ws://<hostname>:<wsPort>` — matches the local dev runner.
 *
 * Never returns a trailing slash.
 */
export function resolveWsBase(wsPort: number): string {
  const envUrl = (import.meta.env as Record<string, string | undefined>).VITE_BACKEND_WS_URL;
  if (envUrl) return envUrl.replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
    const host = window.location.host;
    const apex = host.split('.').slice(-2).join('.');
    return `wss://api.${apex}`;
  }
  return `ws://${window.location.hostname}:${wsPort}`;
}
